import { Input, setComponentTemplate } from "@ember/component";
import { on } from "@ember/modifier";
import { action } from "@ember/object";
import { isEmpty } from "@ember/utils";
import { classNames } from "@ember-decorators/component";
import icon from "discourse/helpers/d-icon";
import discourseComputed from "discourse/lib/decorators";
import SelectKitFilterComponent from "select-kit/components/select-kit/select-kit-filter";
import { precompileTemplate } from "@ember/template-compilation";
const MultiSelectFilter = dt7948.c(class MultiSelectFilter extends SelectKitFilterComponent {
  computedPlaceholder(placeholder, hasSelection) {
    if (this.hidePlaceholderWithSelection && hasSelection) {
      return "";
    }
    return isEmpty(placeholder) ? "" : placeholder;
  }
  static {
    dt7948.n(this.prototype, "computedPlaceholder", [discourseComputed("placeholder", "selectKit.hasSelection")]);
  }
  onPaste(event) {
    const data = event?.clipboardData;
    if (!data) {
      return;
    }
    const parts = data.getData("text").split("|").filter(Boolean);
    if (parts.length > 1) {
      event.stopPropagation();
      event.preventDefault();
      this.selectKit.append(parts);
      return false;
    }
  }
  static {
    dt7948.n(this.prototype, "onPaste", [action]);
  }
  static {
    setComponentTemplate(precompileTemplate("\n    {{#unless this.isHidden}}\n      {{!-- filter-input-search prevents 1password from attempting autocomplete --}}\n      {{!-- template-lint-disable no-pointer-down-event-binding --}}\n\n      <Input tabindex={{0}} class=\"filter-input\" placeholder={{this.computedPlaceholder}} autocomplete=\"off\" autocorrect=\"off\" autocapitalize=\"off\" name=\"filter-input-search\" spellcheck={{false}} @value={{readonly this.selectKit.filter}} @type=\"search\" {{on \"paste\" this.onPaste}} {{on \"keydown\" this.onKeydown}} {{on \"keyup\" this.onKeyup}} {{on \"input\" this.onInput}} />\n\n      {{#if this.selectKit.options.filterIcon}}\n        {{icon this.selectKit.options.filterIcon class=\"filter-icon\"}}\n      {{/if}}\n    {{/unless}}\n  ", {
      strictMode: true,
      scope: () => ({
        Input,
        on,
        icon
      })
    }), this);
  }
}, [classNames("multi-select-filter")]);
export default MultiSelectFilter;